import React from 'react';
import * as S from './OperationRow.styles';
import { DownloadIcon, SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { Operation } from '@/features/Profile/sections/Transactions/Transactions.types';

interface OperationRowProps {
  operation: Operation;
  onShowDetails: (operation: Operation) => void;
}

export const OperationRow = ({
  operation,
  onShowDetails,
}: OperationRowProps) => {
  const {
    ad,
    isRefund,
    serviceName,
    isIncome,
    formattedAmount,
    invoiceId,
    invoiceUrl,
    paymentMethodLabel,
    date,
  } = operation;
  const { title, path = '' } = ad ?? {};

  function handleInvoiceDownloadClick(
    event: React.MouseEvent<HTMLAnchorElement>
  ) {
    event.stopPropagation();
  }

  return (
    <S.Row onClick={() => onShowDetails(operation)}>
      <S.Cell>
        {ad ? (
          <S.AdLink
            href={path}
            onClick={event => event.stopPropagation()}
            title={title}
          >
            {title}
          </S.AdLink>
        ) : null}
      </S.Cell>

      <S.ServiceCell $isRefund={isRefund} title={serviceName}>
        {serviceName}
      </S.ServiceCell>

      <S.Cell>
        <S.Amount $isIncome={isIncome}>{formattedAmount}</S.Amount>
      </S.Cell>

      <S.Cell title={invoiceId ?? paymentMethodLabel}>
        {invoiceUrl ? (
          <S.Invoice>
            <S.InvoiceId title={invoiceId}>{invoiceId}</S.InvoiceId>
            <S.InvoiceDownload
              href={invoiceUrl}
              target="_blank"
              onClick={handleInvoiceDownloadClick}
            >
              <DownloadIcon width={20} height={20} />
            </S.InvoiceDownload>
          </S.Invoice>
        ) : (
          paymentMethodLabel
        )}
      </S.Cell>

      <S.DateCell title={date}>{date}</S.DateCell>

      <S.ChevronCell>
        <SmallChevronIcon width={6} height={12} />
      </S.ChevronCell>
    </S.Row>
  );
};
